/**
 * Parses an ISO 8601 duration string (e.g., "PT1H30M") and returns total minutes
 * Supports hours (H), minutes (M), and days (D)
 */
const parseDurationAsMinutes = (duration: string): number => {
  // Handle empty or invalid input
  if (!duration || typeof duration !== 'string') {
    return 0;
  }

  // Parse ISO 8601 duration format: PT1H30M, PT2H, PT45M, P1DT2H30M
  const pattern = /P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?/;
  const matches = duration.match(pattern);

  if (!matches) {
    return 0;
  }

  const days = parseInt(matches[1] || '0', 10);
  const hours = parseInt(matches[2] || '0', 10);
  const minutes = parseInt(matches[3] || '0', 10);

  return days * 24 * 60 + hours * 60 + minutes;
};

export default parseDurationAsMinutes;
